import { render, staticRenderFns } from "./client.vue?vue&type=template&id=93655572&scoped=true&"
var script = {}
import style0 from "./client.vue?vue&type=style&index=0&id=93655572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93655572",
  null
  
)

export default component.exports